import { isDefined, isNotDefined } from '@hsp/utilities';

import { NotificationTarget } from '@c/notifications/types';

import { notifications } from '@u/notifications';

import { useSignalREffect } from 'hooks/signalr';

import { useAudienceBuilderBroadcasts } from './audience-builder.hook';
import { useExternalListBroadcasts } from './external-list.hook';
import { useNlsManagementBroadcasts } from './nls-management.hook';

export const useBroadcasts = () => {
  useAudienceBuilderBroadcasts();
  useExternalListBroadcasts();
  useNlsManagementBroadcasts();

  useSignalREffect(
    NotificationTarget.Broadcast,
    (notification) => {
      if (isNotDefined(notification)) {
        return;
      }

      const { id: toastId, isError, message } = notification;

      if (isDefined(message)) {
        if (isError) {
          notifications.error(message, undefined, {
            toastId,
          });
        } else {
          notifications.default(message, undefined, {
            toastId,
          });
        }
      }
    },
    []
  );
};
